module.exports = __webpack_public_path__ + "static/media/3.444cdb9c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/3.svg
// module id = 462
// module chunks = 5